module.exports = __webpack_public_path__ + "static/media/HeartOpen.81cb9091.png";